import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import WOW from "wowjs";

const Header = ({ id, dataAbout }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openVideo = () => {
    setIsOpen(true);
  };

  const closeVideo = () => {
    setIsOpen(false);
  };

  const handleKeyUp = (e) => {
    if (e.key === "Escape") {
      closeVideo();
    }
  };

  useEffect(() => {
    const wow = new WOW.WOW({
      live: false, // This disables continuous scanning for new elements
    });
    wow.init();
  }, []);

  return (
    <div id={id}>
      <div>
        <div className="about-area tmp-section-gap about-style-one">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="about-thumbnails">
                  <div className="thumbnail">
                    <img
                      width="410"
                      height="590"
                      className="wow zoomIn"
                      alt="corporate_business"
                      src={dataAbout?.img1}
                    />
                    <div className="image-two wow">
                      <img
                        width="190"
                        height="280"
                        alt="corporate_business"
                        className="wow zoomIn"
                        src={dataAbout?.img2}
                      />
                    </div>
                    <div className="image-three wow">
                      <img
                        width="410"
                        height="200"
                        alt="corporate_business"
                        className="wow zoomIn"
                        src={dataAbout?.img3}
                      />
                    </div>
                    <div className="square" />
                    <div className="flower">
                      <img
                        alt="Corporate_Business"
                        src="assets/images/about/flower.png"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="about-inner">
                  <div className="section-head text-align-left section-head-one-side">
                    <div
                      className="section-sub-title wow slideInUp"
                      data-wow-duration=".4s"
                      data-wow-delay=".1s"
                    >
                      <img
                        alt="Corporate_service"
                        src="assets/images/services/section-custom-menubar.png "
                      />
                      <span className="subtitle">{dataAbout?.subTitle}</span>
                    </div>
                    <h2
                      className="title split-collab wow slideInUp"
                      data-wow-duration=".4s"
                      data-wow-delay=".2s"
                    >
                      {dataAbout?.title}
                    </h2>
                  </div>
                  <p className="description wow slideInUp">{dataAbout?.desc}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
